<template>
  <section class="ctn">
    <header>
      <nav class="tabs">
        <span class="tab" :class="page == 'dashboardSites' ? 'selected':''"><router-link :to="{ path: '/dashboard/sites' }">{{ $t('sites') }}</router-link></span>
        <span class="tab" :class="page == 'dashboardServers' ? 'selected':''"><router-link :to="{ path: '/dashboard/servers' }">{{ $t('servers') }}</router-link></span>
        <span class="spacer"></span>
        <heim-button @click.native="refreshCards"><span class="noShow">{{ $t('refresh') }}</span><heim-icon icon="refresh"></heim-icon></heim-button>
      </nav>
    </header>
    <router-view></router-view>
  </section>
</template>

<script>
// @ is an alias to /src
import HeimButton from "@/components/form/button/heim-button";
import HeimIcon from "@/components/icon/heim-icon";
import { mapState } from "vuex";
export default {
  name: "dashboard",
  components: {
    HeimButton,
    HeimIcon
  },
  mounted() {
    const siteInterval = setInterval(
      () => this.$store.dispatch("getSites"),
      this.refresh
    );
    this.$store.dispatch("saveInterval", {
      name: "sites",
      interval: siteInterval
    });
    const serverInterval = setInterval(
      () => this.$store.dispatch("getServers"),
      this.refresh
    );
    this.$store.dispatch("saveInterval", {
      name: "servers",
      interval: serverInterval
    });
  },
  computed: {
    ...mapState(["refresh"]),
    page() {
      return this.$route.meta.section;
    }
  },
  methods: {
    refreshCards() {
      document
        .querySelector(".paper-button .heim-icon")
        .classList.toggle("rotate");
      this.$store.dispatch("getSites");
      this.$store.dispatch("getServers");
    }
  }
};
</script>
<style scoped>
.tabs {
  border-bottom: solid 1px lightgrey;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.tabs .spacer {
  flex: 1 1 auto;
}
.tabs .tab {
  display: inline-block;
  min-width: 6rem;
  text-align: center;
  border-bottom: solid 3px var(--heim-grey-color);
}

.tabs .tab a {
  display: inline-block;
  padding: 1rem 0.6rem;
  cursor: pointer;
}

.tabs .tab.selected {
  font-weight: bold;
  border-color: var(--heim-secondary-color);
}

.paper-button .heim-icon {
  transition-duration: 0.8s;
  transition-property: transform;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
}

.paper-button .heim-icon.rotate {
  transform: rotate(360deg);
  -webkit-transform: rotate(360deg);
}

@media screen and (max-width: 768px) {
  .noShow {
    display: none;
  }
}
</style>
